import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const PrivateRoute = ({
  component: Component,
  authed,
  registered,
  path,
  ...rest
}) => (
  <Route
    {...rest}
    render={
      (props) => (
        authed && registered
          ? <Component {...props} />
          : (
            <Route
              path={path}
              component={() => {
                if (!registered) {
                  return <Redirect to='/signup/registration' />;
                }

                const currentQueryString = window.location.search;
                const existingParams = new URLSearchParams(currentQueryString);
                const newParams = new URLSearchParams();
                newParams.set('rel', path.replace('/', ''));
                newParams.set('version', '2');
                existingParams.forEach((value, key) => {
                  if (key !== 'rel' && key !== 'version') {
                    newParams.set(key, value);
                  }
                });

                let domain;
                if (process.env.WEBAPP_URL) {
                  domain = process.env.WEBAPP_URL;
                } else {
                  const isDevelop = process.env.ENVIRONMENT === 'DEVELOP' ? 'dev.app-v3' : 'app.';
                  domain = `https://${process.env.ENVIRONMENT === 'STAGING' ? 'staging.app-v3.' : isDevelop}teambuildr.com`;
                }

                window.location.href = `${domain}/login?${newParams.toString()}`;
                return null;
              }}
            />
          )
      )
    }
  />
);

PrivateRoute.propTypes = {
  authed: PropTypes.bool.isRequired,
  component: PropTypes.elementType.isRequired,
  path: PropTypes.string.isRequired,
  registered: PropTypes.bool.isRequired,
};

export default PrivateRoute;
